import styled from 'styled-components';
import struttura from '../images/struttura.jpg'
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';

const About = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 668px)' });
  const { t } = useTranslation();
  let text = t('chiSiamoDescrizione');
  let parts = text.split('.');
  return (
    <Wrapper>
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6" style={isMobile ? {marginBottom: '15px'} : {padding: '25px'}}>
            <div className="imgContainer">
              <img src={struttura} alt="" />
            </div>
          </div>
          <div className="col-12 col-md-6" style={isMobile ? {padding: '5px 5px 20px 5px'} : {padding: '25px'}}>
            <h3>
              {t('chiSiamo')}
            </h3>
            {parts.map((part, index) => {
              if (part !== '') {
                return <p key={index}>
                  {part + '.'}
                </p>
              } else {
                return null;
              }
            })}
          </div>
        </div>
      </div>
    </Wrapper>
  )
}

export default About;


const Wrapper = styled.section`
  .col-12 {
    h3 {
      text-transform: uppercase;
      color: var(--logo);
      display: inline-block;
      font-size: 25px;
      border-bottom: 2px solid var(--logo);
      padding-right: 5px;
      margin-bottom: 10px;
    }
    p {
      margin: 15px 0px;
    }
    img {
      object-fit: cover;
      object-position: center;
      border-radius: 10px;
      /* height: 325px; */
      width: 100%;
    }
  }
`